module.exports = __webpack_public_path__ + "img/Etiqueta_PTI_Detalle.db59b06f.png";